<div class="p8-bdc_hero__container p8-dark-theme">
  <div class="mat-display-2 p8-bdc_hero__display-text">{{ site.heading_hero }}</div>
  <div class="p8-bdc_hero__search">
    <p8-bdc-search-pages></p8-bdc-search-pages>
  </div>
</div>
